import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ResearcherContext } from "../../ResearcherContext";
import SignUpCard from "../components/SignUpCard";

import SignUpBackgroundImage from "../../../../../assets/images/researcher_app/sign_up/sign_up_background_desktop.png";



function SignUp(props) {


    const navigate = useNavigate();
    const location = useLocation();
    const { researcher, setResearcher, refreshResearcher } = useContext(ResearcherContext);


    return (
        <div className="signup-overall-container">
            <SignUpBackground />
            <PreAuthHeaderSignUp />
            <SignUpContainer>
                <SignUpTitle />
                <SignUpCard />
            </SignUpContainer>
        </div>

    );

}

function SignUpBackground() {
    const backgroundStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: '100%', // Viewport height
        minHeight: "100vh",
        width: '100%', // Viewport width
        backgroundImage: `url(${SignUpBackgroundImage})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%', // Stretch in both directions
        backgroundAttachment: 'fixed', // Background stays fixed during scrolling
        zIndex: 0
    };

    return (
        <div style={backgroundStyle} />
    )
}

function PreAuthHeaderSignUp() {
    return (
        <div className="sign-up-header-container">
            <div className="sign-up-logo" >
                de<span className="logo-accent">spark</span>
            </div>
        </div>
    )
}

function SignUpContainer({ children }) {
    return (
        <div className="sign-up-container">
            {children}
        </div>
    )
}

function SignUpTitle() {
    return (
        <div className="sign-up-title-container">
            <div className="sign-up-title">
                Make Your <span className="sign-up-title-highlight">User Research</span> Easy
            </div>
            <div className="sign-up-copy">
                Get feedback from users today
            </div>
        </div>
    )
}






export default SignUp
